import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function addBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.child.map((child, i) => {
    if (child.current != null && child.current?.child.current?.props.sectionName === 'ApprovalConditionTemplatePreset') {
      child.current?.setState({ showModal: true, componentType: 'Create' });

      //必须如下顺序设置, 否则再次弹出时无法清空已选项
      setTimeout(() => {
        child.current?.customForm.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys: [], approvalConditionTemplatePresetContentList: [] });
        child.current?.customForm.current?.additionalFormRef.current?.child.current?.getApprovalConditionTemplateData();
      }, config.setTimeoutMilliSecond * 10);
    }
  })
}

export function editBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });
  setTimeout(() => {
    httpClient
      .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
      .then(({ data }) => {
        if (data.result) {
          sectionComponent.customForm.current?.setState({ currentDataKey: data.data.key });

          //把处理后的数据赋值给表单
          sectionComponent.customForm.current?.formRef.current?.setFieldsValue(data.data);
          sectionComponent.customForm.current?.setState({ formData: data.data });

          //获取编辑时的原 approvalConditionTemplatePresetContent 列表, 设置默认选中项 defaultSelectedRowKeys
          let defaultSelectedRowKeys = [];
          let approvalConditionTemplatePresetContentList = [];
          data.data.ApprovalConditionTemplatePresetContentList.map((approvalConditionTemplatePresetContent, i) => {
            defaultSelectedRowKeys.push(approvalConditionTemplatePresetContent.ApprovalConditionTemplateId);
            approvalConditionTemplatePresetContentList.push(approvalConditionTemplatePresetContent);
          })
          setTimeout(() => {
            sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys, approvalConditionTemplatePresetContentList, selectedRowKeys: [] });
            //先设置完默认选中项, 再获取实际 ApprovalConditionTemplate 列表, 否则会设置不上
            sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.getApprovalConditionTemplateData();
          }, config.setTimeoutMilliSecond * 10);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
}

export function showSelectedItemsOnlyOnChange({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let filteredData;
  if (parameter) {
    filteredData = sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.state.data.map((folder) => {
      // 使用对象的拷贝
      let newFolder = { ...folder };
      newFolder.ApprovalConditionTemplateList = folder.ApprovalConditionTemplateList.filter((item) =>
        sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.state.approvalConditionTemplatePresetContentList.map(item => item.ApprovalConditionTemplateId).includes(item.key)
      );
      return newFolder;
    });
  } else {
    filteredData = [...sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.state.data];
  }
  sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ filteredData });
}
